import { useQuery } from '@tanstack/react-query'
import { verifyCardIssueStatus } from '../walletServices'

const twoMinutesInMs = 2 * 60 * 1000

interface QueryOptions {
  enabled?: boolean
}

export const useVerifyCardIssueStatus = (queryOptions: QueryOptions = {}) =>
  useQuery({
    queryKey: ['identity-card-state'],
    queryFn: verifyCardIssueStatus,
    staleTime: twoMinutesInMs,
    refetchInterval: twoMinutesInMs,
    enabled: queryOptions?.enabled ?? true,
    retry: false,
  })
